import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col-reverse items-center justify-center gap-6 md:flex-row md:gap-16',
    more: 'w-full max-w-100 flex-1',
    pagination: 'flex items-center justify-center',
    ellipsis: 'flex h-10 w-6 items-center justify-center sm:size-12.5'
  }
});
